import "./src/styles/index.css"
